import {
  gaMeasurementId,
  hasAnalyticsConsent,
  metaPixelId,
  redditPixelId,
} from "./analyticsConfig";

const GA_SCRIPT_ID = "studyradar-ga4-script";
const META_SCRIPT_ID = "studyradar-meta-pixel-script";
const REDDIT_SCRIPT_ID = "studyradar-reddit-pixel-script";

let gaInitialized = false;
let metaInitialized = false;
let redditInitialized = false;
let lastTrackedNavigationKey = null;

function initializeGoogleAnalytics() {
  if (!gaMeasurementId || typeof window === "undefined") return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!gaInitialized) {
    if (!document.getElementById(GA_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = GA_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
        gaMeasurementId
      )}`;
      document.head.appendChild(script);
    }

    window.gtag("js", new Date());
    window.gtag("config", gaMeasurementId, { send_page_view: false });
    gaInitialized = true;
  }

  return true;
}

function initializeMetaPixel() {
  if (!metaPixelId || typeof window === "undefined") return false;

  if (!window.fbq) {
    const fbq = function fbq() {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };

    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
  }

  if (!metaInitialized) {
    if (!document.getElementById(META_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = META_SCRIPT_ID;
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(script);
    }

    window.fbq("init", metaPixelId);
    metaInitialized = true;
  }

  return true;
}

function initializeRedditPixel() {
  if (!redditPixelId || typeof window === "undefined") return false;

  if (!window.rdt) {
    // Mirrors Reddit's own stub: pixel.js replays callQueue, then assigns sendEvent.
    const rdt = function rdt() {
      if (rdt.sendEvent) {
        rdt.sendEvent.apply(rdt, arguments);
      } else {
        rdt.callQueue.push(arguments);
      }
    };

    rdt.callQueue = [];
    window.rdt = rdt;
  }

  if (!redditInitialized) {
    if (!document.getElementById(REDDIT_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = REDDIT_SCRIPT_ID;
      script.async = true;
      script.src = "https://www.redditstatic.com/ads/pixel.js";
      document.head.appendChild(script);
    }

    window.rdt("init", redditPixelId);
    redditInitialized = true;
  }

  return true;
}

export function initializeAnalytics() {
  if (!hasAnalyticsConsent()) {
    return { ga: false, meta: false, reddit: false };
  }

  return {
    ga: initializeGoogleAnalytics(),
    meta: initializeMetaPixel(),
    reddit: initializeRedditPixel(),
  };
}

export function trackPageView({ path, navigationKey }) {
  if (navigationKey && navigationKey === lastTrackedNavigationKey) return;

  const initialized = initializeAnalytics();
  let tracked = false;

  if (initialized.ga) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
    tracked = true;
  }

  if (initialized.meta) {
    window.fbq("track", "PageView");
    tracked = true;
  }

  if (initialized.reddit) {
    window.rdt("track", "PageVisit");
    tracked = true;
  }

  if (tracked && navigationKey) {
    lastTrackedNavigationKey = navigationKey;
  }
}
